import client from "../client";

export function getSalaryExpectations(page?: number) {
  return client.get(`/api/v2/salary_expectations${page ? `?page=${page}` : ""}`);
}
